<template>
  <v-container
    fluid>
    <v-row>
      <v-col cols="12">
        <v-btn-toggle
          class="flex-wrap"
          v-model="toggle_exclusive"
          @change="changeSelected"
          color="teal">
          <v-btn
            v-for="(dataName, ind) in interviewToggles"
            :key="ind"
            outlined
            tile>
            {{ dataName }}
          </v-btn>
          <v-btn><v-icon>description</v-icon></v-btn>
        </v-btn-toggle>
        <v-btn
          icon
          @click="goToInfo()"
        ><v-icon color="blue">fa-info-circle</v-icon></v-btn>
      </v-col>
    </v-row>

    <template v-if="toggle_exclusive === 0">
      <v-row
        v-for="(interviews, index) in newInterview"
        :key="index">
        <interview-card
          :interviews="interviews"
          :caregiver-email="caregiverEmail"
          :caregiver-name="caregiverName"
          :pupil-name="pupilName"
          :message-send="messageToSend"
          @get-interviews="getInterviews"
        />
      </v-row>

      <v-alert
        v-if="newInterview.length === 0"
        dense
        type="info"
      >
        No New Interview To Book
      </v-alert>
    </template>
    <template v-if="toggle_exclusive === 1">
      <interview-upcoming
        :up-coming-interviews="upComingInterviews"
        @get-upcoming-interview="getUpcomingInterview"
      />
      <v-alert
        dense
        type="info"
        v-if="upComingInterviews.length === 0"
      >
        No Upcoming Interview
      </v-alert>

    </template>
    <template v-if="toggle_exclusive === 2">
      <interview-all
        :all-booking="allBooking"
        @get-all-booked-interviews="getAllBookedInterviews"/>
      <v-alert
        dense
        type="info"
        v-if="allBooking.length === 0"
      >
        No Interview Record
      </v-alert>

    </template>
    <template v-if="toggle_exclusive === 3">

      <interview-feedback :feedback="feedbackArray"/>
      <v-alert
        dense
        type="info"
        v-if="feedbackArray.length === 0"
      >
        No data
      </v-alert>
    </template>

  </v-container>
</template>

<script>
import InterviewCard from '../components/InterviewCard.vue'
import InterviewUpcoming from '../components/InterviewUpcoming.vue'
import InterviewAll from '../components/InterviewAll.vue'
import InterviewFeedback from '../components/InterviewFeedback.vue'

export default {
  data: () => ({
    interviewAlert: true,
    tealColor: '#00B0B9',
    newInterview: [],
    messageToSend: '',
    bookedInterviews: [],
    selectedBookingId: '',
    caregiverEmail: '',
    caregiverName: '',
    pupilName: '',
    upComingInterviews: [],
    toggle_exclusive: 0,
    interviewToggles: ['New', 'Upcoming', 'All'],
    allBooking: [],
    feedbackArray: {}
  }),
  components: {
    InterviewCard,
    InterviewUpcoming,
    InterviewAll,
    InterviewFeedback
  },
  computed: {

  },
  methods: {
    goToInfo: function () {
      var url = 'https://etap.co.nz/publicfiles/parent-app-tutorial.php'
      window.open(url)
    },
    changeSelected: function () {
      if (this.toggle_exclusive === 0) {
        this.getInterviews()
      } else if (this.toggle_exclusive === 1) {
        this.getUpcomingInterview()
      } else if (this.toggle_exclusive === 2) {
        this.getAllBookedInterviews()
      } else if (this.toggle_exclusive === 3) {
        this.getFeedbacks()
      }
    },
    getFeedbacks: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/feedbacksV2')
        .then(resp => {
          this.feedbackArray = resp.data.feedbackArray
          this.$store.commit('loading', false)
        })
    },
    getDetails: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/' + this.$store.state.trueUser + '/confirmDetailsV2')
        .then(resp => {
          this.caregiverEmail = resp.data.emailAddress
          this.caregiverName = resp.data.caregiverName
          this.pupilName = resp.data.pupilName
          this.$store.commit('loading', false)
        })
    },

    getInterviews: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/' + this.$store.state.userId + '/interviewsV2')
        .then(resp => {
          this.newInterview = resp.data.newInterview
          this.messageToSend = resp.data.messageToSend
          this.$store.commit('loading', false)
        })
    },
    checkBookedHistory: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/bookedInterviewsV2')
        .then(resp => {
          this.bookedInterviews = resp.data.bookedInterviews
          this.$store.commit('loading', false)
        })
    },
    getUpcomingInterview: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/onGoingInterviewV2')
        .then(resp => {
          this.totalUpcoming = resp.data.total
          this.upComingInterviews = resp.data.onGoingInterview
          this.$store.commit('loading', false)
        })
    },
    getAllBookedInterviews: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/allBookedInterviewV2')
        .then(resp => {
          this.allBooking = resp.data.allBookedInterview
          this.$store.commit('loading', false)
        })
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
      vm.getInterviews()
      vm.getDetails()
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
